import './query-input.scss';

import { faBarcode, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { BarcodeSubscriber } from '@skinsoft/ui';
import { keyboard$ } from '@skinsoft/ui/src/barcode/keyboard';

@Component({
    components: {
        sBarcodeSubscriber: BarcodeSubscriber
    },
    props: ['debounceTime', 'placeholder', 'barcodeEnabled'],
    template: require('./query-input.html'),
})
export class QueryInput extends ReactiveVue {
    public debounceTime: number;
    public barcodeEnabled: boolean;

    // Icons
    public searchIcon = faSearch;
    public barcodeIcon = faBarcode;

    public value: string = '';
    public activeBarcode = false;

    private readonly INPUT_FILTER_IDENTIFIER: string = "search-query-input"

    private value$ = new Subject();

    public mounted() {

        keyboard$.
            pipe(
                filter(
                    inputEvent => inputEvent.inputEventIdentifier === this.INPUT_FILTER_IDENTIFIER
                )
            )
            .subscribe(value => {
                this.value = value.char
            })

        this.subscribeTo(this.value$.pipe(debounceTime(this.debounceTime)), value => {
            this.$emit('input', value);
        });
    }

    public beforeDestroy() {
        this.unsuscribeFromQueryParams();
    }

    public unsuscribeFromQueryParams() {
        this.unsubscribeFrom('value');
    }

    private toggleBarcodeScanner() {
        this.activeBarcode = !this.activeBarcode;
    }

    @Watch('value', { immediate: true, deep: true })
    private onValueChange() {
        this.value$.next(this.value);
    }
}
